// extracted by mini-css-extract-plugin
export default {"signInPage":"SignInPage_signInPage__f7uX8","actionButton":"SignInPage_actionButton__0hRA9"};